import pl from "@locales/chat/pl.json";
import en from "@locales/chat/en.json";

export default {
  pl: pl,
  en: en,
};
